<template>
  <b-card header="Opciones de Filtro" class="card-filter">
    <b-btn class="filter-collapse" 
        variant="primary" 
        size="sm"
        @click.prevent="showOpcionesFiltro= !showOpcionesFiltro">
      <i :class="showOpcionesFiltro ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
    </b-btn>
    <b-collapse id="filtro" class="mt-2" v-model="showOpcionesFiltro">
      <b-form>
        <b-form-group
          label="Nombre"
          label-for="nombre"
          :label-cols="labelCols"
          horizontal>
          <b-form-input 
            id="nombre" 
            v-model="filtro.nombre" 
            type="text">
          </b-form-input>
        </b-form-group>
        <b-form-group
          label-for="inactivo"
          :label-cols="labelCols">
          <b-form-checkbox 
              id="inactivo"
              v-model="filtro.incluirInactivos"
              value= true
              unchecked-value= false>
              {{ incluirInactivosLeyenda }}
          </b-form-checkbox>
        </b-form-group>
      </b-form>
      <div class="footer">
        <b-button size="sm" variant="primary" class="footer-button"
          @click.prevent="filtrar">Filtrar</b-button>
        <b-button size="sm" variant="primary" class="footer-button" 
          @click.prevent="limpiarFiltro">Limpiar</b-button>
      </div>
    </b-collapse>
  </b-card>

</template>

<script>
export default {
  props: {
    nombre: {
      type: String,
      default: ''
    },
    incluirInactivos: {
      type: Boolean,
      default: false    
    },
    incluirInactivosLeyenda: {
      type: String,
      default: 'Incluir inactivos'
    },
    showOpcionesInicio: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      filtro: {
        nombre: '',
        incluirInactivos: false,
      },
      
      showOpcionesFiltro: Boolean(false),
      labelCols: 1
    }
  },
  created() {
      this.filtro.nombre = this.nombre;
      this.filtro.incluirInactivos = this.incluirInactivos;
      this.showOpciones = this.showOpcionesInicio;
  },
  computed: {
  },     
  methods: {
    filtrar() {
      this.$emit('filtrar', this.filtro);
    },
    limpiarFiltro() {
      this.filtro.nombre = '';
      this.filtro.incluirInactivos = false;
      /*this.$emit('limpiarFiltro');*/
    }
  },
}
</script>

<style>
</style>
